import { render, staticRenderFns } from "./PdTabQualityItem.vue?vue&type=template&id=8a0c40e4&scoped=true&"
import script from "./PdTabQualityItem.vue?vue&type=script&lang=ts&"
export * from "./PdTabQualityItem.vue?vue&type=script&lang=ts&"
import style0 from "./PdTabQualityItem.vue?vue&type=style&index=0&id=8a0c40e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c40e4",
  null
  
)

export default component.exports